import React, { FC, RefObject, useEffect, useRef, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import { OrderType } from 'types/checkout'
import { FlexRow } from 'components/Flex'
import { Checkbox } from 'components/Form'
import { HorizontalLine, Spacer } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'
import { findBreadShortName } from 'lib/helper'

type Props = {
  order: OrderType
}

const PrintDeliveryOrderBody: FC<Props> = (props) => {
  const { order } = props
  const breads = useSelector((state: State) => getBreads(state))
  const [minWidth, setMinWidth] = useState<number>(0)
  const refs = useRef<RefObject<HTMLDivElement>[]>([])
  order.items.map((_, i) => (refs.current[i] = React.createRef()))
  useEffect(() => {
    if (!refs.current) return
    const max = Math.max(...refs.current.map((ref) => ref.current?.clientWidth || 0))
    setMinWidth(max)
  }, [refs.current])
  return (
    <>
      {order.items.map((item, i) => {
        // 引当在庫数判定の改修によりquantityが0の場合もありえるが非表示とする
        if (!item.checkout_item_ref || item.quantity === 0) return
        const breadName = findBreadShortName(breads, item.bread_name, item.bread_ref)
        return (
          <React.Fragment key={item.checkout_item_ref.id}>
            <FlexRow justifyContent={'start'}>
              <div ref={refs.current[i]} style={{ minWidth }}>
                <Checkbox
                  disabled={true}
                  fontSize={16}
                  id={item.checkout_item_ref.id}
                  isChecked={false}
                  label={breadName}
                />
              </div>
              <Spacer size={48} axis={'horizontal'} />
              <p className={text.font_mediumLarge} style={{ minWidth: '40px' }}>
                {item.quantity}個
              </p>
            </FlexRow>
            {order.items.length !== i + 1 && <HorizontalLine color={'grey04'} verticalMargin={8} />}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default PrintDeliveryOrderBody
